<template>
  <div v-if="pestana == 1">
    <ModalConfirmacion titulo="titulo" cuerpo="cuerpo" ref="modalConfirmacion"></ModalConfirmacion>
    <div slot="title">
      <h2>Evaluaciones En Proceso</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px;">
          <div class="col-4"></div>
          <div class="col-3">
            <select v-model="FiltroNotificadaAux" class="form-control">
              <option value="" selected>Todos</option>
              <option value="1">Notificados</option>
              <option value="0">Sin Notificar</option>
            </select>
          </div>
          <div class="col-4">
            <input type="text" placeholder="Buscar.." name="search" class="form-control" v-model="nombreEvaluadoBusqueda" v-on:keyup.enter="buscarEvaluacionesFront">
          </div>
          <div class="col-1 text-left">
            <button type="submit" class="form-control" @click="buscarEvaluacionesFront"><i class="fa fa-search"></i></button>
          </div>
        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-12">
            <table class="table table-striped table-light table-hover" id="tablaEvaluaciones">
              <thead class="thead-dark">
                <tr>
                  <th>
                    Número de Solicitud
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(0,true)' title="Ordenar por Número de Solicitud" /></div>
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(0,false)' title="Ordenar por Número de Solicitud" /></div>
                  </th>
                  <th>Nombre</th>
                  <th>Puesto</th>
                  <th>
                    Departamento
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(3,true)' title="Ordenar por Departamento" /></div>
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(3,false)' title="Ordenar por Departamento" /></div>
                  </th>
                  <th>Evaluadores Pendientes</th>
                  <th>
                    Fecha de Entrega
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-up' @click='ordenar(5,true)' title="Ordenar por Fecha de Entrega" /></div>
                    <div class="row"><div class="col-8"></div><i class='fa fa-sort-down' @click='ordenar(5,false)' title="Ordenar por Fecha de Entrega" /></div>
                  </th>
                  <th>
                    Notificada
                  </th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody class='text-dark'>
                <template v-for='(evaluacion, indice) in evaluaciones'>
                  <tr v-if="!evaluacion.FiltradoFront" v-bind:key="evaluacion.EvaluacionId">
                    <td>#{{ evaluacion.SolicitudEvaluacionId }}</td>
                    <td>{{evaluacion.nombreEvaluado}}</td>

                    <td>{{evaluacion.Puesto}} <i v-if="evaluacion.AlertaHistorialLaboral" class="fas fa-exclamation-triangle" title="Problema de Historial Laboral. Favor de notificar a personal." /></td>
                    <td>{{evaluacion.Seccion}} - {{evaluacion.Departamento}}</td>
                    <td>
                      <ul>
                        {{evaluacion.noCuestionariosContestados}} / {{evaluacion.noCuestionarios}}
                        <template v-for="evaluador in evaluacion.evaluadores"  >
                          <li v-if="!evaluador.Contestado" v-bind:key="evaluador.idCuestionario">{{ evaluador.Evaluador.NombreCompleto}}</li>
                        </template>
                      </ul>
                    </td>
                    <td>{{evaluacion.FechaLimiteEntregaString}}</td>
                    <td>
                      <input type="checkbox" v-model="evaluacion.Notificada" @click="marcarNotificada(evaluacion)" />
                    </td>
                    <td class='d-flex justify-content-around'>
                      <i class='fa fa-info-circle' @click='BorrarEvaluadores(evaluacion.EvaluacionId, indice)' title="Ver Detalles de Evaluación" />
                      <i class='fa fa-edit' @click='EditarEvaluacion(evaluacion.EvaluacionId, indice)' title="Agregar Evaluadores" />
                      <!--<i class='fa fa-trash' @click='pedirConfirmacion(evaluacion.EvaluacionId,evaluacion.nombreEvaluado)' title="Desactivar Evaluación" />-->
                    </td>
                  </tr>
                </template>
                <tr v-if="evaluaciones.length == 0"><td colspan="8">No se encontraron evaluaciones en proceso</td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="pestana != 1">
    <EditarEvaluacion :idEvaluacion="idEvaluacion" v-if="pestana == 2"></EditarEvaluacion>
    <BorrarEvaluadores :idEvaluacion="idEvaluacion" v-if="pestana == 3" v-on:valorParaElPadre="regresarLista"></BorrarEvaluadores>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'
  import store from '@/store/index'
  import catalogos from '@/../static/js/catalogos'
  import EditarEvaluacion from '@/components/SISEVA/Evaluaciones/EditarEvaluacion.vue'
  import BorrarEvaluadores from '@/components/SISEVA/Evaluaciones/BorrarEvaluadores.vue'
  export default {
    data() {
      return {
        nombreEvaluadoBusqueda : "",//Contiene en valor del nombre del evaluado para busqueda
        textoBusqueda_norm : "",//Contiene en valor del nombre del evaluado para busqueda
        evaluaciones: [],
        columna: 0,
        sentido: true,
        FiltroNotificadaAux: "",
        IdEvaluacionSeleccionada: null,
        pestana: 1,
        idEvaluacion: null,
        indiceEvaluacion: null
      }
    },
    components: {
      ModalConfirmacion: catalogos.SISEVA.ModalConfirmacion,
      EditarEvaluacion,
      BorrarEvaluadores
    },
    methods: {
      pedirConfirmacion: function (id, nombre) {
        var mensaje = "¿Está seguro de desactivar la evaluación para "+nombre+"?"
        var titulo = "Confirmación de desactivación"
        this.IdEvaluacionSeleccionada = id
        this.$refs.modalConfirmacion.mostrar(titulo, mensaje, this.desactivarEvaluacion);
      },
      buscarEvaluaciones: function () { //Retorna una lista de evaluaciones pendientes en base a ciertos filtros
        //Carga la información necesaria para hacer la petición
        var peticion = {
          "esPrueba": false,
          "nombreEvaluadoBusqueda": this.nombreEvaluadoBusqueda,
          "estatusSolicitud": 2,
          "EstatusEvaluacion": 2,
          "Notificada": this.FiltroNotificada
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluaciones, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            //console.log(response);
            $("#alertaNumeroNomina").hide();//Oculta la alerta de número de nómina no válido (filtro de busqueda)
            this.evaluaciones = response.data.evaluaciones//Carga los datos necesarios
            this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', 10)
            })
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });

      },
      buscarEvaluacionesFront: function () {
        comun.SeEstaCargandoInformacion(true);
        this.textoBusqueda_norm = this.nombreEvaluadoBusqueda.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
        this.evaluaciones.forEach(this.cicloEvaluaciones);
        this.$forceUpdate();
        this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', 10)
            })
        comun.SeEstaCargandoInformacion(false);
      },
      cicloEvaluaciones: function (evaluacion) {
        var nombreEvaluado_norm = evaluacion.nombreEvaluado.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
        var seccion_norm = evaluacion.Seccion.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
        var departamento_norm = evaluacion.Departamento.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
        //console.log(seccion_norm)
        evaluacion.FiltradoFront = !(nombreEvaluado_norm.includes(this.textoBusqueda_norm) || seccion_norm.includes(this.textoBusqueda_norm) || departamento_norm.includes(this.textoBusqueda_norm))
          || (this.FiltroNotificada != null && (evaluacion.Notificada != this.FiltroNotificada));
      },
      comparar: function (a, b) {
        var SeccionA = 0;
        var SeccionB = 0;
        if (this.columna == 0) {
          SeccionA = a.SolicitudEvaluacionId;
          SeccionB = b.SolicitudEvaluacionId;
        } else if (this.columna == 3) {
          SeccionA = a.Seccion.toUpperCase();
          SeccionB = b.Seccion.toUpperCase();
        } else if (this.columna == 5) {
          var from = a.FechaLimiteEntregaString.split("/");
          SeccionA = new Date(from[2], from[1] - 1, from[0]);
          from = b.FechaLimiteEntregaString.split("/");
          SeccionB = new Date(from[2], from[1] - 1, from[0]);
        } else {
          return 0;
        }
        if (!this.sentido) {
          var aux;
          aux = SeccionA;
          SeccionA = SeccionB;
          SeccionB = aux;
        }
        let comparison = 0;
        if (SeccionA > SeccionB) {
          comparison = 1;
        } else if (SeccionA < SeccionB) {
          comparison = -1;
        }
        
        return comparison;
      },
      ordenar: function (columna, sentido) {
        this.columna = columna
        this.sentido = sentido
        this.evaluaciones.sort(this.comparar);
        this.$nextTick(() => {
              PaginarTabla('tablaEvaluaciones', 10)
            })
      }, verDetalles: function (idEvaluacion, idSolicitud) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.$router.push({
        name: 'DetallesEvaluacion',
        params: { idEvaluacion: idEvaluacion, infoPersona: null }
    })
      },
      EditarEvaluacion: function (idEvaluacion,indice) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.idEvaluacion = idEvaluacion
        this.indiceEvaluacion = indice 
        this.pestana = 2;
      },
      BorrarEvaluadores: function (idEvaluacion, indice) {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        this.idEvaluacion = idEvaluacion
        this.indiceEvaluacion = indice
        this.pestana = 3;
      },
      actualizarEvaluacionEditada: function () {
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluacionSoloNombresEvaluadores, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.evaluaciones[this.indiceEvaluacion] = response.data.evaluacion;
            this.$forceUpdate();
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },
      marcarNotificada: function (evaluacion) {
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": evaluacion.EvaluacionId,
          "Notificada": evaluacion.Notificada
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.MarcarEvaluacionNotificada, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      },      
      desactivarEvaluacion: function () {
        //Redirige a la página SISEVA/DetallesEvaluado, para modificar la evaluación que se haya seleccionado, se envia el id de evaluación como parametro
        
        var peticion = {
          "esPrueba": false,
          "EvaluacionId": this.IdEvaluacionSeleccionada
        };
        comun.SeEstaCargandoInformacion(true);
        axios.post(api.conexion + api.SISEVA.funcion.DesactivarEvaluacion, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            this.buscarEvaluaciones()
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          comun.SeEstaCargandoInformacion(false);
        }).catch(e => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
        });
      },
      regresarLista(datos) {
        this.pestana = 1;
        this.actualizarEvaluacionEditada();
      }
    }, mounted: function mounted(){//Al cargarse la vista hace la busqueda de evaluaciones sin filtros
     this.buscarEvaluaciones()
    }, computed: {
      FiltroNotificada: function () {
        if (this.FiltroNotificadaAux == "1") { return true;}
        else if (this.FiltroNotificadaAux == "0") { return false;}
        else { return null;}
      }
    }

  }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/EvaluacionesEnProceso.vue